import { MaterialGradeType, PartTypeSchema } from "../types";
import { ExtendedPart } from "../types";
import { checkPartDimensions } from "./checkPartDimensions";

export const canPredict = (
  part: ExtendedPart,
  materialGrade: MaterialGradeType | null,
  {
    skipDimensionsCheck = false,
  }: {
    skipDimensionsCheck?: boolean;
  } = {},
): materialGrade is MaterialGradeType => {
  if (part.type === PartTypeSchema.enum.CONSUMABLE) {
    return false;
  }

  if (materialGrade === null) {
    return false;
  }

  if (skipDimensionsCheck) {
    return true;
  }

  const isPartAnalyzed = part.graphStatus === "PROCESSED" || part.analyze2DStatus === "PROCESSED";
  return !checkPartDimensions(part).hasError && isPartAnalyzed;
};
